import { AfterViewInit, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import computedToInline from 'computed-style-to-inline-style';

import printJS from 'print-js';

//declare var printJS: any;

@Component({
    selector: 'upsc-ship-details-print-dialog',
    templateUrl: './ship-details-print-dialog.component.html',
    styleUrls: ['./ship-details-print-dialog.component.scss'],

    // Required for styling inner HTML.
    encapsulation: ViewEncapsulation.None,
})
export class ShipDetailsPrintDialogComponent implements AfterViewInit {
    public htmlContent: string;

    // public cssContent: string;

    constructor(public dialogRef: MatDialogRef<ShipDetailsPrintDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.htmlContent = this.data.htmlContent;
        // this.cssContent = this.data.cssContent;
    }

    public ngAfterViewInit(): void {
        computedToInline(document.getElementById('print-ship-details'), { recursive: true });
        printJS({ printable: 'print-ship-details', type: 'html', showModal: true, targetStyles: ['*'] });
    }
}
